import classNames from 'classnames'
import React from 'react'
import {Button} from 'wix-ui-tpa/cssVars'
import {useColors} from '../../../../hooks/colors'
import {StyledButtonProps} from './interfaces'
import {classes} from './styled-button.st.css'

export const StyledButton: React.FC<StyledButtonProps> = ({
  dataHook,
  onClick,
  children,
  disabled = false,
  fullWidth = true,
  secondary = false,
  className,
}) => {
  const {darkColor} = useColors()

  const getClassName = () => {
    if (secondary && !darkColor) {
      return classes.secondaryDark
    }
    if (secondary) {
      return classes.secondary
    }
    if (!darkColor) {
      return classes.regularDark
    }
    return classes.regular
  }

  return (
    <Button
      data-hook={dataHook}
      fullWidth={fullWidth}
      upgrade
      className={classNames(classes.button, getClassName(), className)}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Button>
  )
}
